import React from "react";

const Prose = ({ children }) => (
  <article className="prose prose-neutral prose-lg prose-li:marker:text-current max-w-none prose-emerald dark:prose-invert dark:prose-hr:border-neutral-600 dark:prose-tr:border-neutral-600">
    {children}
  </article>
);

export default Prose;
